import * as yup from "yup";
import { createEmailSchema, createRequiredTrimmedString } from "./schemaUtils";

export const userProfileSchema = yup
  .object({
    first_name: createRequiredTrimmedString("First name is required"),
    last_name: createRequiredTrimmedString("Last name is required"),
    email: createEmailSchema({
      requiredMessage: "Email is required",
      invalidMessage: "Invalid mail address",
    }),
    team: yup.string(),
    isActive: yup.boolean().required("Is active is required"),
    worklogsRequired: yup.boolean().required("Worklogs is required"),
    isSuperAdmin: yup.boolean().required(),
  })
  .required();
